module.exports = __webpack_public_path__ + "img/icon-document.b988ecef.svg";